"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Send = _interopRequireDefault(require("@material-ui/icons/Send"));

var _formik = require("formik");

var _yup = require("yup");

var _reactRedux = require("react-redux");

var _notistack = require("notistack");

var _nicaLocatorCore = require("../nicaLocatorCore");

var _customField = _interopRequireDefault(require("../_common/formik/customField"));

var _actions = require("../../redux/login/actions");

var _selectors = require("../../redux/login/selectors");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Login = function Login(_ref) {
  var onClose = _ref.onClose,
      hideToolbar = _ref.hideToolbar;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showEmailSent = _useState2[0],
      setShowEmailSent = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useLoginSelector = (0, _selectors.useLoginSelector)(),
      loggingIn = _useLoginSelector.loggingIn;

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      _useContext$images = _useContext.images,
      logo = _useContext$images.logo,
      loginBackgroundImage = _useContext$images.loginBackgroundImage;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "login-container flex column"
  }, !hideToolbar && /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "sticky",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "home-toolbar-title-container text-align-left flex w100"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "nica logo",
    className: "login-nica-logo"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-content flex column center flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "login-background",
    style: {
      backgroundImage: "url(".concat(loginBackgroundImage, ")")
    }
  }), /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: "login-card"
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, loggingIn ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "login-title"
  }, "Logging In"), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-message"
  }, "Please wait while we attempt to log you in."), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-content-center marginTop10"
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 30
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !showEmailSent ? /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: {
      email: ''
    },
    onSubmit: function onSubmit(values) {
      setEmail(values.email);
      setShowEmailSent(true);
      dispatch((0, _actions.initEmailLinkAuth)(values.email, enqueueSnackbar));
    },
    validationSchema: (0, _yup.object)().shape({
      email: (0, _yup.string)().email('Please enter a valid Email address').required('Please enter an Email Address')
    })
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "bodyFont login-title"
    }, "Enter Your Email to Continue"), /*#__PURE__*/_react.default.createElement("div", {
      className: "login-message"
    }, "You will be emailed a link to login"), /*#__PURE__*/_react.default.createElement("div", {
      className: "marginTop10"
    }, /*#__PURE__*/_react.default.createElement(_customField.default, {
      name: "email",
      label: "Email",
      placeholder: "john.smith@gmail.com",
      CustomComponent: _TextField.default,
      fullWidth: true
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "flex justify-end marginTop20"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "marginRight10"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "text",
      color: "default",
      onClick: onClose
    }, "Cancel")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "submit",
      variant: "contained",
      color: "primary"
    }, /*#__PURE__*/_react.default.createElement(_Send.default, {
      className: "marginRight5"
    }), "Send Email Link")))));
  }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "login-title"
  }, "Check Your Email"), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-message"
  }, "A link has been sent to ", email, " to login."), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-end marginTop10"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setShowEmailSent(false);
    }
  }, "Go Back"))))))));
};

var _default = Login;
exports.default = _default;